import React from "react";
import PropTypes from "prop-types";
import {apiPost, apiRequest} from "../../utils/request";
import ReactTable from "react-table";
import {Aux, IsNullOrUndefined} from "../../constants";
import moment from "moment";
import {Button, Collapse, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter} from "reactstrap";
import {toastr} from "react-redux-toastr";
import {some} from 'lodash';
import QrReader from "react-qr-reader";
import querySearch from "stringquery";
import TankAssignView from "./TankAssignView";

class TankChecklistView extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            tanks: [],
            selectedTank: null,
            lookupTank: null,
            isModalOpen: false,
            isCollapsed: props.showCollapsed,
            canScan: true,
        };
        this.getTankColumns = this.getTankColumns.bind(this);
        this.fetchTanksToBeDelivered = this.fetchTanksToBeDelivered.bind(this);
        this.handleAssignTank = this.handleAssignTank.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.handleFinaliseTankAssignment = this.handleFinaliseTankAssignment.bind(this);
        this.handleSetTankId = this.handleSetTankId.bind(this);
        this.handleLookupTank = this.handleLookupTank.bind(this);
        this.onScan = this.onScan.bind(this);
        this.onScanError = this.onScanError.bind(this);
    }

    fetchTanksToBeDelivered() {
        // This changes to be a check list which assigns tankId's to drop-offs and notifies the driver of pickups
        // Drop offs must be done before check-in can happen

        let {runId} = this.props;
        apiRequest(`/api/tanks/rundelivery?runId=${runId}`)
            .then(x => {
                if (x.data) {
                    this.setState({tanks: Array.from(x.data)});
                }
            });
    }

    handleAssignTank(e, tank){
        e.preventDefault();
        this.setState({selectedTank: tank, isModalOpen: true, lookupTank: null});
    }

    toggleModal(){
        this.setState({selectedTank: null, isModalOpen: false, lookupTank: null});
    }

    handleLookupTank() {
        let {selectedTank} = this.state;
        
        this.setState({lookupTank: null}, ()=> {
            apiRequest(`/api/tanks/?id=${selectedTank.tankId}`)
                .then(x => {
                    if (x.data && x.data.notFound === true) {
                        toastr.error(`Tank #${selectedTank.tankId} information NOT found`);
                        this.setState({lookupTank: null, canScan: true});
                    } else {
                        this.setState({lookupTank: x.data, canScan: true});
                    }
                });
        });
    }
    
    handleFinaliseTankAssignment(tank) {        
        let {runId} = this.props;

        apiPost(`/api/managelocations/${tank.locationId}/tanks/assign/${runId}`, tank)
            .then(_ => this.setState({selectedTank: null, lookupTank: null, isModalOpen: false}, () => {
                this.fetchTanksToBeDelivered();
                this.props.onUpdate();
            }));
    }

    handleSetTankId(e) {
        let tankId = parseInt(e.target.value);
        let {selectedTank} = this.state;

        if (tankId > 0) {
            this.setState({selectedTank: {...selectedTank, tankId}, lookupTank: null});
        } else {
            this.setState({selectedTank: {...selectedTank, tankId: null}, lookupTank: null});
        }
    }


    
    getTankColumns(){
        return [
            {
                id: 'tankId',
                accessor: x => IsNullOrUndefined(x.tankRequestTankAssignedDate) && IsNullOrUndefined(x.tankId) ? <a href={''} onClick={(e) => this.handleAssignTank(e, x)}>Assign</a> : !IsNullOrUndefined(x.tankRequestTankAssignedId) ? `#${x.tankRequestTankAssignedId}` : `#${x.tankId}`,
                Header: 'Tank Id',
                maxWidth: 80,
            },
            {
                id: 'tank',
                accessor: x => x.tankName,
                Header: 'Tank',
            },{
                id: 'tankStatusTypeString',
                Header: 'Status',
                accessor: x => x.tankStatusTypeString,
                maxWidth: 150,
            },{
                id: 'tankRequestHasHeater',
                Header: 'Heater',
                accessor: x => x.tankRequestHasHeater ? "Yes" : "No",
                maxWidth: 80,
            }            
            ,{
                id: 'tankRequestActionString',
                Header: 'Action',
                accessor: x => x.tankRequestActionString,
                maxWidth: 80,
            },
            {
                id: 'assignedDate',
                Header: 'Assigned',
                accessor: x => IsNullOrUndefined(x.tankRequestTankAssignedDate) ? '' : (moment(x.tankRequestTankAssignedDate).format('DD/MM/YYYY')),
                maxWidth: 100,
            },
            {
                id: 'completedDate',
                Header: 'Completed',
                accessor: x => IsNullOrUndefined(x.tankRequestActionCompleteDate) ? '' : (moment(x.tankRequestActionCompleteDate).format('DD/MM/YYYY')),
                maxWidth: 100,
            }
        ];
    }

    onScan(data) {
        let {selectedTank, canScan} = this.state;        
        
        if (data && canScan) {
            if (data.includes('?')) {
                let split = data.split('?');
                let query = querySearch(`?${split[1]}`);

                if(selectedTank.tankId !== query.tankId) {
                    this.setState({
                        selectedTank: {...selectedTank, tankId: query.tankId},
                        lookupTank: null,
                        canScan: false
                    }, () => {
                        this.handleLookupTank();
                    });
                }

            } else {
                this.setState({scanResult: data, canScan: true, status: 'Scan does not contain a tankId'});
            }
        }
    }
    
    onScanError(data){
        console.log(data);
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.showCollapsed !== this.props.showCollapsed) {
            this.setState({isCollapsed: this.props.showCollapsed}, () => this.fetchTanksToBeDelivered());
        }
    }

    componentDidMount() {
        this.fetchTanksToBeDelivered();
    }

    render() {
        let {tanks, isModalOpen, selectedTank, lookupTank, isCollapsed} = this.state;
        let {baseLocationIds} = this.props;
        // Get a list of tanks to be exchanged, driver must scan (enter tank Id) for each, this becomes the assignment        
        let canAssign = !IsNullOrUndefined(lookupTank) && baseLocationIds.length > 0 &&
            (some(baseLocationIds, x => x === lookupTank.currentTankLocationId))
            && selectedTank.tankSizeId === lookupTank.tankSizeId
            && selectedTank.tankRequestHasHeater === lookupTank.hasHeater
            && lookupTank.isConsideredPending === false
            && lookupTank.isInactive === false;

        return (
            <Aux>
                <div className="row mb-1">
                    <div className="col-12">
                        <h5>
                            <a href={""} onClick={(e)=>{ 
                                e.preventDefault();
                                this.setState({isCollapsed: !isCollapsed}, ()=> this.fetchTanksToBeDelivered());}}>{isCollapsed ? 'Show Tank Assignments' : 'Hide Tank Assignments'}</a>
                        </h5>
                    </div>
                </div>                
                <Collapse isOpen={!isCollapsed}>
                
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-block">
                                    <ReactTable
                                        sortable={tanks.length > 20}
                                        filterable={false}
                                        showPagination={tanks.length > 20}
                                        data={tanks}
                                        columns={this.getTankColumns()}
                                        minRows={2}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </Collapse>

                <TankAssignView 
                    onTankAssigned={this.handleFinaliseTankAssignment} 
                    onCancel={this.toggleModal} 
                    baseLocationIds={baseLocationIds}
                    selectedTank={selectedTank}
                    basicMatch={false}
                />
                
                {/*<Modal isOpen={isModalOpen} toggle={this.toggleModal}>*/}
                {/*    <ModalBody>*/}
                {/*        <Form onSubmit={e => {*/}
                {/*            e.preventDefault();*/}
                {/*            if(lookupTank && canAssign){*/}
                {/*                this.handleFinaliseTankAssignment()*/}
                {/*            } else {*/}
                {/*                this.handleLookupTank();    */}
                {/*            }                            */}
                {/*        }}>*/}
                {/*            {selectedTank &&*/}
                {/*            <Aux>*/}
                {/*                <div className={"row"}>*/}
                {/*                    <div className={"col-12"}><h5>Lookup Tank</h5></div>*/}
                {/*                </div>*/}
                {/*                <div className={"row"}>*/}
                {/*                    <div className={"col-3"}>Tank</div>*/}
                {/*                    <div className={"col-9"}>{selectedTank.tankName}</div>*/}
                {/*                </div>*/}
                {/*                <div className={"row"}>*/}
                {/*                    <div className={"col-3"}>Heater</div>*/}
                {/*                    <div className={"col-9"}>{selectedTank.tankRequestHasHeater ? "Requires heater" : "Not required"}</div>*/}
                {/*                </div>*/}
                {/*            </Aux>*/}
                {/*            }*/}
                
                {/*            <FormGroup>*/}
                {/*                <Label for="tankId">Tank #</Label>*/}
                {/*                <Input type="number"*/}
                {/*                       name="tankId"*/}
                {/*                       id="tankId"*/}
                {/*                       value={IsNullOrUndefined(selectedTank) || IsNullOrUndefined(selectedTank.tankId) ? '' : selectedTank.tankId}*/}
                {/*                       onChange={this.handleSetTankId}*/}
                {/*                />*/}
                {/*            </FormGroup>*/}
                
                {/*            <div className={"row"}>*/}
                {/*                <div className={"col-12"}>*/}
                {/*                    <QrReader*/}
                {/*                        delay={300}*/}
                {/*                        onError={this.onScanError}*/}
                {/*                        onScan={this.onScan}*/}
                {/*                        style={{ width: '100%' }}*/}
                {/*                    />        */}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*            */}
                {/*            */}
                
                {/*        </Form>*/}
                
                {/*        {lookupTank &&*/}
                {/*        <Aux>*/}
                {/*            <div className={"row mt-2"}>*/}
                {/*                <div className={"col-12"}><h5>Found Tank {lookupTank.idWithPrefix}</h5></div>*/}
                {/*            </div>*/}
                {/*            <div className={"row"}>*/}
                {/*                <div className={"col-3"}>Tank</div>*/}
                {/*                <div className={"col-9"}>{lookupTank.formattedName}</div>*/}
                {/*            </div>*/}
                {/*            <div className={"row"}>*/}
                {/*                <div className={"col-3"}>Location</div>*/}
                {/*                <div className={"col-9"}>{lookupTank.currentTankLocationName}</div>*/}
                {/*            </div>*/}
                {/*            <div className={"row"}>*/}
                {/*                <div className={"col-3"}>Status</div>*/}
                {/*                <div className={"col-9"}>{lookupTank.tankStatusTypeString}</div>*/}
                {/*            </div>                            */}
                {/*            <div className={"row"}>*/}
                {/*                <div className={"col-3"}>Heater</div>*/}
                {/*                <div className={"col-9"}>{lookupTank.hasHeater ? "Yes" : "No"}</div>*/}
                {/*            </div>*/}
                
                {/*            {!canAssign && <div className={"row text-warning"}>*/}
                {/*                <div className={"col-12"}>The looked up tank is not at the base or drop off*/}
                {/*                    location or it is of the wrong type or status*/}
                {/*                </div>*/}
                {/*            </div>}*/}
                {/*        </Aux>*/}
                {/*        }*/}
                {/*    </ModalBody>*/}
                {/*    <ModalFooter>*/}
                {/*        <FormGroup>*/}
                {/*            {IsNullOrUndefined(lookupTank) && <Button color="info"*/}
                {/*                                                      className={"mr-1"}*/}
                {/*                                                      onClick={this.handleLookupTank}>Lookup*/}
                {/*                Tank</Button>}*/}
                
                {/*            {canAssign && <Button color="success"*/}
                {/*                                  className={"mr-1"}*/}
                {/*                                  onClick={this.handleFinaliseTankAssignment}>Assign*/}
                {/*                Tank</Button>}*/}
                {/*            <Button onClick={this.toggleModal}>Cancel</Button>*/}
                {/*        </FormGroup>*/}
                {/*    </ModalFooter>*/}
                {/*</Modal>*/}
            </Aux>);
    }
}

TankChecklistView.propTypes = {
    runId: PropTypes.number.isRequired,
    baseLocationIds: PropTypes.array.isRequired,    
    onUpdate: PropTypes.func.isRequired,
    showCollapsed: PropTypes.bool.isRequired,
};

export default TankChecklistView;